import {h} from 'hastscript'

import {VoidElementWidget} from './void-element'

/** Renders an empty `span` element. `EmptySpanWidget` is a singleton and cannot be constructed. */
export const EmptySpanWidget = new VoidElementWidget(h('span'))
